import { render, staticRenderFns } from "./CreateProjectEdit.vue?vue&type=template&id=9b832732&scoped=true"
import script from "./CreateProjectEdit.vue?vue&type=script&lang=js"
export * from "./CreateProjectEdit.vue?vue&type=script&lang=js"
import style0 from "./CreateProjectEdit.vue?vue&type=style&index=0&id=9b832732&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b832732",
  null
  
)

export default component.exports